var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoilChair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0469 116.641V118.234C55.0469 120.125 55.0469 122.07 54.5312 125.047L52.7656 124.891C53.3125 122.117 53.3125 120.07 53.3125 118.234V118.047H45.1719V116.641H55.0469ZM43.8125 127.453V126.031H56.6875V127.453H43.8125ZM70.5469 126.297V127.719H57.6406V126.297H70.5469ZM59.1406 117.672V116.266H69.0156V120.812H60.9062V122.656H69.3438V124.031H59.1719V119.422H67.2969V117.672H59.1406ZM84.375 126.297V127.719H71.4688V126.297H84.375ZM72.9688 117.672V116.266H82.8438V120.812H74.7344V122.656H83.1719V124.031H73V119.422H81.125V117.672H72.9688ZM96.4375 115.281V118.297H98.4219V119.719H96.4375V122.734H94.7031V115.281H96.4375ZM85.25 121.469C88.7109 120.75 90.4219 119.203 90.6484 117.328H85.9531V115.922H92.5938C92.5859 119.625 90.2031 121.945 85.9062 122.891L85.25 121.469ZM86.625 124.641V123.359H91.3438V126.844H88.3594V127.938C90.2891 127.938 91.1875 127.883 92.25 127.641L92.4219 128.938C91.1719 129.219 90.1562 129.242 87.5625 129.234H86.6562V125.625H89.6562V124.641H86.625ZM91.9531 124.703V123.359H96.4375V129.297H94.7188V124.703H91.9531Z",
    fill: "#242424"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_5300)",
    filter: "url(#filter0_i_1275_5300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.022 49.0005C119.022 75.5258 97.5277 97.0205 71.0024 97.0205C44.4771 97.0205 22.9824 75.5258 22.9824 49.0005C22.9824 22.4751 44.4771 0.980469 71.0024 0.980469C97.5277 0.980469 119.022 22.4751 119.022 49.0005Z",
    fill: "url(#paint0_linear_1275_5300)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1275_5300)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1539 31.8698C93.1719 31.9617 93.1878 32.0427 93.211 32.1007C93.2566 32.2146 92.8894 35.621 92.4494 39.7029C91.821 45.5332 91.044 52.7415 91.109 53.7013C91.109 55.0842 90.2793 70.6277 90.0027 75.5508C89.9474 76.3805 89.256 77.0443 88.4263 77.0443H88.0667C87.1817 77.0443 86.4902 76.3252 86.4902 75.4678C86.4902 71.5404 86.4349 61.4178 85.8541 57.9606C85.3563 55.1118 84.001 54.4204 82.2863 54.3651L81.4289 69.0236C81.3736 69.8533 80.6821 70.5171 79.8524 70.5171C79.0227 70.5171 78.3312 69.881 78.2759 69.0513L77.3355 54.697C76.0554 54.7815 75.3079 54.8819 74.6141 54.975C73.7189 55.0952 72.913 55.2034 71.1679 55.2501H71.1126C69.2713 55.2008 68.4073 55.0928 67.3993 54.9669C66.7116 54.881 65.9569 54.7867 64.779 54.697L63.8386 69.0513C63.7833 69.881 63.0919 70.5171 62.2621 70.5171C61.4324 70.5171 60.741 69.8533 60.6857 69.0236L59.8283 54.3651C58.1135 54.448 56.7583 55.1118 56.2604 57.9606C55.652 61.4178 55.6243 71.5404 55.6243 75.4678C55.6243 76.3529 54.9052 77.0443 54.0478 77.0443H53.6883C52.8586 77.0443 52.1671 76.3805 52.1118 75.5508C52.0384 74.0981 51.9119 71.7205 51.7702 69.0549C51.4315 62.6874 51.0055 54.6761 51.0055 53.7013C51.0055 52.8364 50.3529 46.8983 49.7559 41.4664C49.2265 36.6495 48.7409 32.2307 48.7929 32.1007C48.8161 32.0427 48.832 31.9617 48.85 31.8698C48.918 31.5232 49.0163 31.022 49.6503 31.022H52.1395C52.1395 31.022 53.0522 30.3859 54.7669 25.5735C56.4182 20.9126 62.5835 20.9452 64.2479 20.954C64.3119 20.9544 64.3693 20.9547 64.4194 20.9547H77.7781C77.8284 20.9547 77.8858 20.9544 77.9495 20.954C79.6018 20.9452 85.5859 20.9133 87.237 25.5735C88.9517 30.3859 89.8644 31.022 89.8644 31.022H92.3536C92.9876 31.022 93.0859 31.5232 93.1539 31.8698ZM62.0685 46.8422L63.2578 27.8967C63.3685 26.4585 62.6494 25.1033 60.7133 25.8501C59.4837 26.3244 58.8342 27.8251 58.1484 29.4098C57.7544 30.3202 57.3484 31.2583 56.8136 32.0454C55.7073 33.7878 55.5413 33.8431 54.7116 33.9814C52.4437 34.0367 52.7756 35.8068 52.7756 35.8068C53.9372 48.0591 58.4731 47.4783 58.4731 47.4783H60.8793C62.0962 47.506 62.0685 46.8422 62.0685 46.8422ZM68.8447 39.9831C69.0659 39.9831 69.2319 39.8172 69.2319 39.5959V29.086C69.2319 28.8648 69.0659 28.6988 68.8447 28.6988C68.6234 28.6988 68.4575 28.8648 68.4575 29.086V39.5959C68.4575 39.8172 68.6234 39.9831 68.8447 39.9831ZM73.3805 39.9831C73.6018 39.9831 73.7677 39.8172 73.7677 39.5959V29.086C73.7677 28.8648 73.6018 28.6988 73.3805 28.6988C73.1593 28.6988 72.9933 28.8648 72.9933 29.086V39.5959C72.9933 39.8172 73.1593 39.9831 73.3805 39.9831ZM83.5309 47.4783C83.5309 47.4783 88.0944 48.0315 89.2283 35.8068C89.2283 35.8068 89.5602 34.0367 87.2923 33.9814C86.4626 33.8431 86.2966 33.7878 85.1903 32.0454C84.5831 31.1517 84.2796 30.0634 83.9948 29.042C83.5921 27.5978 83.2267 26.2875 82.0927 25.8501C80.1566 25.1033 79.4099 26.4862 79.5205 27.8967L80.7098 46.8422C80.7098 46.8422 80.6821 47.506 81.8991 47.4783H83.5309ZM71.0852 47.5059C76.7827 47.5059 77.2805 47.3952 77.2805 47.2569C77.2805 47.1187 76.8104 47.008 71.0852 47.008C65.3878 47.008 64.6963 47.1187 64.6963 47.2569C64.6963 47.3952 65.3878 47.5059 71.0852 47.5059Z",
    fill: "#C8A262"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1275_5300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.492 48.9999C113.492 72.4668 94.4687 91.4905 71.0018 91.4905C47.535 91.4905 28.5113 72.4668 28.5113 48.9999C28.5113 25.533 47.535 6.50933 71.0018 6.50933C94.4687 6.50933 113.492 25.533 113.492 48.9999Z",
    stroke: "#C8A262",
    strokeWidth: 2.56553
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1275_5300",
    x: 22,
    y: 0,
    width: 98,
    height: 99.0262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5300"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1275_5300",
    x: 48.7891,
    y: 20.9531,
    width: 44.4258,
    height: 57.117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5300"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1275_5300",
    x: 27.2285,
    y: 5.22656,
    width: 87.5469,
    height: 88.5731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_5300",
    x1: 37.6824,
    y1: 11.4338,
    x2: 107.752,
    y2: 79.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2B589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1B088"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_5300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white",
    transform: "translate(22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoilChair);
export default __webpack_public_path__ + "static/media/SoilChair.5cb0c9eb7a62b673bd9ad984a8670a08.svg";
export { ForwardRef as ReactComponent };